// ErrorPage.js
import React from "react";

const ErrorPage = () => {
  return (
    <div className="flex items-center justify-center h-screen">
      <h1 className="text-2xl font-bold text-gray-800">404 - Page Not Found</h1>
    </div>
  );
};

export default ErrorPage;
